import { makeStyles } from '@mui/styles'
import { Avatar, Container } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import SearchOffIcon from '@mui/icons-material/SearchOff'

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 2, 6),
    },
    avatar: {
        margin: theme.spacing(4),
        backgroundColor: theme.palette.primary.main,
    },
}))

export const NotFound = () => {
    const classes = useStyles()
    const { t } = useTranslation()

    return <div className={classes.heroContent}>
        <Container maxWidth='md'>
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <SearchOffIcon />
                </Avatar>
                <Typography variant='h5' align='center' color='textSecondary' paragraph>
                    {t('error-page.not-found-title')}
                </Typography>
                <Typography variant='body1' align='center' color='textSecondary' paragraph>
                    {t('error-page.not-found-text')}
                </Typography>
            </div>
        </Container>
    </div>
}

